const DEFAULT_OPTIONS = {
  rootMargin: '0px',
  threshold: 0,
};

export default class Observer {
  observerInstance;

  constructor(options) {
    this.options = options || DEFAULT_OPTIONS;
    this.observerInstance = this.buildObserver();
  }

  observe(element) {
    this.observerInstance.observe(element);
  }

  buildObserver() {
    return new IntersectionObserver((entries) => {
      const [observedElement] = entries;

      const event = observedElement.isIntersecting
        ? new Event('sticky-container:in-view')
        : new Event('sticky-container:out-of-view');

      window.dispatchEvent(event);
    }, this.options);
  }
}
